// extracted by mini-css-extract-plugin
export default {"mainContainer":"Modal_mainContainer__jHHzG","container":"Modal_container__xCq5K","showContainer":"Modal_showContainer__QQ4x1","body":"Modal_body__tw5Vn"};